(function() {
  let upsellSwiper = null;
  const DEBOUNCE_DELAY = 100;
  let previousCartCount = 0;
  let isCartUpdating = false;
  let shopCurrency = "USD";

  /* --------------------------------------------------------
   * 🧭 SWIPER INITIALIZATION WITH SMOOTH TRANSITIONS
   * -------------------------------------------------------- */
  function initUpsellSwiper() {
    const swiperEl = document.querySelector('.upsell-swiper');
    if (!swiperEl) {
      console.log('❌ Upsell swiper element not found');
      return;
    }

    // Start hidden for smooth entrance
    swiperEl.style.opacity = '0';
    swiperEl.style.visibility = 'hidden';

    if (upsellSwiper) {
      upsellSwiper.destroy(true, true);
      upsellSwiper = null;
    }

    const slides = swiperEl.querySelectorAll('.swiper-slide');
    if (slides.length === 0) {
      console.log('❌ No slides found in upsell swiper');
      hideUpsellSection();
      return;
    }

    upsellSwiper = new Swiper(swiperEl, {
      slidesPerView: 2.3,
      spaceBetween: 15,
      init: false
    });

    upsellSwiper.init();
    swiperEl.classList.remove('loading');
    swiperEl.classList.add('swiper-initialized');
    
    // Smooth reveal after initialization
    setTimeout(() => {
      swiperEl.style.opacity = '1';
      swiperEl.style.visibility = 'visible';
      swiperEl.style.transition = 'opacity 0.4s ease, visibility 0.4s ease';
    }, 100);
    
    console.log('✅ Upsell Swiper initialized with', slides.length, 'slides');
  }

  /* --------------------------------------------------------
   * 🎯 UPSELL SECTION VISIBILITY WITH SMOOTH TRANSITIONS
   * -------------------------------------------------------- */
  function hideUpsellSection() {
    const upsellCustom = document.querySelector('.upsell-custom');
    if (upsellCustom) {
      // Smooth fade out before hiding
      upsellCustom.style.opacity = '0';
      upsellCustom.style.transition = 'opacity 0.3s ease';
      setTimeout(() => {
        upsellCustom.style.display = 'none';
        upsellCustom.style.opacity = '1'; // Reset for next show
      }, 300);
      upsellCustom.classList.remove('loading-parent');
    }
  }

  function showUpsellSection() {
    const upsellCustom = document.querySelector('.upsell-custom');
    if (upsellCustom) {
      // Start hidden then fade in
      upsellCustom.style.display = 'block';
      upsellCustom.style.opacity = '0';
      setTimeout(() => {
        upsellCustom.style.opacity = '1';
        upsellCustom.style.transition = 'opacity 0.4s ease';
      }, 50);
      upsellCustom.classList.remove('loading-parent');
    }
  }

  function showUpsellLoading() {
    const upsellCustom = document.querySelector('.upsell-custom');
    if (upsellCustom) {
      upsellCustom.style.display = 'block';
      upsellCustom.classList.add('loading-parent');
    }
  }

  /* --------------------------------------------------------
   * 🛒 CART UPDATE FUNCTIONS WITH SMOOTH ITEM UPDATES
   * -------------------------------------------------------- */
  function updateCartBubble(count) {
    const bubble = document.querySelector('.cart-count-bubble');
    if (bubble) bubble.textContent = count;
  }

  function attachUpsellEventListeners() {
    console.log('🔄 Attaching upsell event listeners');
    
    document.querySelectorAll('.upsell-item .button--primary').forEach(button => {
      button.removeEventListener('click', handleUpsellButtonClick);
      button.addEventListener('click', handleUpsellButtonClick);
    });
  }

  function handleUpsellButtonClick(event) {
    event.preventDefault();
    event.stopPropagation();
    
    const upsellItem = event.target.closest('.upsell-item');
    if (!upsellItem) return;
    
    const variantId = upsellItem.dataset.variantId;
    if (variantId) {
      console.log('🛒 Adding variant to cart:', variantId);
      
      const button = event.target;
      const originalText = button.textContent;
      button.textContent = 'Adding...';
      button.disabled = true;
      
      addToCart(variantId, button, originalText);
    }
  }

  function addToCart(variantId, buttonElement, originalText) {
    if (isCartUpdating) return;
    
    isCartUpdating = true;
    showUpsellLoading();

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ 
        items: [{ 
          id: variantId, 
          quantity: 1 
        }] 
      })
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      console.log('✅ Added to cart:', data);
      updateCartAndUpsell(data);
    })
    .catch(error => {
      console.error('❌ Error adding item to cart:', error);
      if (buttonElement && originalText) {
        buttonElement.textContent = originalText;
        buttonElement.disabled = false;
      }
      isCartUpdating = false;
      showUpsellLoading();
    });
  }

  /* --------------------------------------------------------
   * 📦 OPTIMIZED CART UPDATE WITH SMOOTH TRANSITIONS
   * -------------------------------------------------------- */
  function updateCartAndUpsell(cartData) {
    const drawerInner = document.querySelector('.drawer__inner');
    
    if (drawerInner) {
      drawerInner.classList.add('drawer-updating');
    }

    showUpsellLoading();

    fetch('/cart.js')
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to fetch cart');
        }
        return response.json();
      })
      .then(cart => {
        if (cart.currency) {
          shopCurrency = cart.currency;
        }
        
        updateCartBubble(cart.item_count);
        previousCartCount = cart.item_count;
        
        return fetch('/cart?section_id=cart-drawer');
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to fetch cart drawer');
        }
        return response.text();
      })
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newCartDrawer = doc.querySelector('cart-drawer');
        
        if (newCartDrawer) {
          const currentCartDrawer = document.querySelector('cart-drawer');
          if (currentCartDrawer) {
            currentCartDrawer.innerHTML = newCartDrawer.innerHTML;
            
            // Wait for DOM to update, then initialize everything
            setTimeout(() => {
              // Re-initialize swiper (important for delete operations)
              initUpsellSwiper();
              attachUpsellEventListeners();
              
              // Then check cart and update visibility with smooth transitions
              fetch('/cart.js')
                .then(res => res.json())
                .then(currentCart => {
                  const visibleItemsCount = updateAllUpsellItemsWithTransition(currentCart);
                  
                  // Delay for smooth transition completion
                  setTimeout(() => {
                    if (visibleItemsCount === 0) {
                      hideUpsellSection();
                    } else {
                      showUpsellSection();
                    }
                    
                    if (drawerInner) {
                      drawerInner.classList.remove('drawer-updating');
                    }
                    isCartUpdating = false;
                    
                    console.log('🎉 Upsell section updated with', visibleItemsCount, 'visible items');
                  }, 400);
                });
            }, 400);
          }
        }
      })
      .catch(error => {
        console.error('❌ Cart update error:', error);
        if (drawerInner) {
          drawerInner.classList.remove('drawer-updating');
        }
        const visibleItemsCount = updateAllUpsellItemsWithTransition(cartData || {items: []});
        if (visibleItemsCount === 0) {
          hideUpsellSection();
        } else {
          showUpsellSection();
        }
        isCartUpdating = false;
      });
  }

  /* --------------------------------------------------------
   * 🎯 SMOOTH ITEM VISIBILITY UPDATES
   * -------------------------------------------------------- */
  function updateAllUpsellItemsWithTransition(cartData) {
    const upsellItems = document.querySelectorAll('.upsell-item');
    let visibleItemsCount = 0;
    
    upsellItems.forEach(item => {
      const variantId = parseInt(item.dataset.variantId);
      const isInCart = cartData.items && cartData.items.some(cartItem => cartItem.variant_id === variantId);
      
      if (isInCart) {
        // Smooth fade out for items that should be hidden
        if (item.style.display !== 'none') {
          item.style.opacity = '0';
          item.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
          item.style.transform = 'translateX(-10px)';
          setTimeout(() => {
            item.style.display = 'none';
            // Reset for when item reappears
            item.style.opacity = '1';
            item.style.transform = 'translateX(0)';
          }, 300);
        }
      } else {
        // Smooth fade in for items that should be shown
        if (item.style.display === 'none') {
          item.style.display = 'block';
          item.style.opacity = '0';
          item.style.transform = 'translateX(10px)';
          // Small delay for staggered animation
          setTimeout(() => {
            item.style.opacity = '1';
            item.style.transform = 'translateX(0)';
            item.style.transition = 'opacity 0.4s ease, transform 0.4s ease';
          }, 50);
        } else {
          // Already visible, ensure proper state
          item.style.opacity = '1';
          item.style.transform = 'translateX(0)';
        }
        visibleItemsCount++;
      }
    });
    
    return visibleItemsCount;
  }

  // Keep the original function for initial load
  function updateAllUpsellItems(cartData) {
    const upsellItems = document.querySelectorAll('.upsell-item');
    let visibleItemsCount = 0;
    
    upsellItems.forEach(item => {
      const variantId = parseInt(item.dataset.variantId);
      const isInCart = cartData.items && cartData.items.some(cartItem => cartItem.variant_id === variantId);
      
      if (isInCart) {
        item.style.display = 'none';
      } else {
        item.style.display = 'block';
        visibleItemsCount++;
      }
    });
    
    return visibleItemsCount;
  }

  /* --------------------------------------------------------
   * 🚀 IMPROVED INITIALIZATION
   * -------------------------------------------------------- */
  function initializeUpsellSystem() {
    console.log('🚀 Initializing upsell system...');
    
    showUpsellLoading();
    
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeUpsellComponents);
    } else {
      initializeUpsellComponents();
    }
  }

  function initializeUpsellComponents() {
    console.log('🔧 Initializing upsell components...');
    
    fetch('/cart.js')
      .then(res => {
        if (!res.ok) throw new Error('Failed to fetch initial cart');
        return res.json();
      })
      .then(cart => {
        previousCartCount = cart.item_count;
        updateCartBubble(cart.item_count);
        console.log('🛒 Initial cart count:', cart.item_count);
        
        initUpsellSwiper();
        attachUpsellEventListeners();
        
        const visibleItemsCount = updateAllUpsellItems(cart);
        
        setTimeout(() => {
          if (visibleItemsCount === 0) {
            hideUpsellSection();
          } else {
            showUpsellSection();
          }
          console.log('🎉 Upsell section initialized with', visibleItemsCount, 'visible items');
        }, 300);
      })
      .catch(err => {
        console.error('❌ Initial cart fetch error:', err);
        initUpsellSwiper();
        attachUpsellEventListeners();
        showUpsellSection();
      });
  }

  /* --------------------------------------------------------
   * 🔄 PERIODIC CART SYNC WITH SMOOTH UPDATES
   * -------------------------------------------------------- */
  setInterval(() => {
    if (isCartUpdating) return;
    
    fetch('/cart.js')
      .then(res => {
        if (!res.ok) throw new Error('Failed to fetch cart in interval');
        return res.json();
      })
      .then(cart => {
        if (cart.item_count !== previousCartCount) {
          console.log('🔄 Cart count changed, updating...');
          previousCartCount = cart.item_count;
          updateCartBubble(cart.item_count);
          updateCartAndUpsell(cart);
        }
      })
      .catch(err => console.error('❌ Periodic cart check error:', err));
  }, 500);

  // Initialize the system
  initializeUpsellSystem();

})();


class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0, event);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      return this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        event,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      return fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      return fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, event, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
    const eventTarget = event.currentTarget instanceof CartRemoveButton ? 'clear' : 'change';

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        CartPerformance.measure(`${eventTarget}:paint-updated-sections"`, () => {
          const quantityElement =
            document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
          const items = document.querySelectorAll('.cart-item');

          if (parsedState.errors) {
            quantityElement.value = quantityElement.getAttribute('value');
            this.updateLiveRegions(line, parsedState.errors);
            return;
          }

          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartDrawerWrapper = document.querySelector('cart-drawer');
          const cartFooter = document.getElementById('main-cart-footer');

          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

          this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          });
          const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
          let message = '';
          if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
            if (typeof updatedValue === 'undefined') {
              message = window.cartStrings.error;
            } else {
              message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
            }
          }
          this.updateLiveRegions(line, message);

          const lineItem =
            document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
            cartDrawerWrapper
              ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
              : lineItem.querySelector(`[name="${name}"]`).focus();
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
          } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
          }
        });

        CartPerformance.measureFromEvent(`${eventTarget}:user-action`, event);

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
              .then(() => CartPerformance.measureFromEvent('note-update:user-action', event));
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
